import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import Datetime from 'react-datetime'

export default function Timesheet() {
    const [listTimeArray, setListTimeArray] = useState([]);
    const [listMemberTimeArray, setListMemberTimeArray] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        var company_id = localStorage.getItem('mem_company_id');
        var obj = {
            companyId: company_id
        }
        $.ajax({
            type: 'POST',
            url: 'getAllTimesheetSummary.php',
            data: obj,
            dataType: 'json',
            cache: false,
            success: function (result) {


                if (Array.isArray(result) && result.length > 0) {
                    setListTimeArray(result);
                } else {
                    showAlert('No lst 30 days time history found for your company.');
                    setListTimeArray([]);
                }
            },
        });
    }, [])

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function goForTimeDetails(user_id, com_id) {

        var obj = {
            user_id: user_id,
            company_id: com_id
        }

        console.log(obj)

        $.ajax({
            type: 'POST',
            url: 'getMemberTimesheetDetails.php',
            data: obj,
            dataType: 'json',
            cache: false,
            success: function (result) {
                console.log(result)
                if (Array.isArray(result) && result.length > 0) {

                    setListMemberTimeArray(result);
                    $('.camp_log_pop').show();

                } else {

                    showAlert('No time history found.');

                }
            }
        });
    }

    const downloadPDF = () => {
        const doc = new jsPDF()

        doc.text('Timesheet', 14, 15)
        doc.text(`Generated On: ${new Date().toDateString()}`, 14, 25)
        doc.text(`Name: ${localStorage.getItem('membername')}`, 14, 35)

        autoTable(doc, {
            head: [['#', 'Task', 'Task Details', 'Date', 'Start Time', 'End Time', 'Worked Time']],
            body: listMemberTimeArray.map((task, index) => ([
                index + 1,
                task.task_name,
                task.task_details,
                task.dateofWork,
                task.start_time,
                task.end_time,
                task.time_worked
            ])),
            startY: 45
        })

        doc.save('timesheet-report.pdf');
    }

    function closePopup() {
        $('.camp_log_pop').hide();
    }

    function filterTimesheet(user_id, company_id) {
        if (!startDate || !endDate) {
            showAlert('Please select both dates.');
            return;
        }
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
        var obj = {
            user_id: user_id,
            company_id: company_id,
            start_date: formatDate(startDate),
            end_date: formatDate(endDate)
        };
        $.ajax({
            type: 'POST',
            url: 'filterMemberTimesheet.php',
            data: obj,
            dataType: 'json',
            cache: false,
            success: function (result) {
                if (Array.isArray(result) && result.length > 0) {
                    setListMemberTimeArray(result);
                    $('.camp_log_pop').css('display', 'flex');
                } else {
                    showAlert('No filtered records found.');
                    setListMemberTimeArray([]);
                }
            }
        });
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Member's Timesheet</h2>
                    <p className='fullwidth pull_left pb-30'>Here you can view the total working hours of each team member and filter the records by a specific date range.</p>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_listing_area'>
                        <div className='vl_listing_row'>
                            <div className='vl_listing_cell width20'>
                                <h4 className='prj_name'>Member Name</h4>
                            </div>
                            <div className='vl_listing_cell width20'>
                                <p>Working hours</p>
                            </div>
                            <div className='vl_listing_cell width40'>
                                <p>Filter</p>
                            </div>
                            <div className='vl_listing_cell width20'>
                                <p>View Details</p>
                            </div>
                        </div>
                        {listTimeArray.map((item, index) => {

                            return (
                                <div className='vl_listing_row' key={index}>
                                    <div className='vl_listing_cell width20'>
                                        <h4 className='prj_name'>{item.user_name}</h4>
                                    </div>
                                    <div className='vl_listing_cell width20 prdetails'>
                                        <p>{item.total_worked}</p>
                                    </div>
                                    <div className='vl_listing_cell width40'>
                                        <div className='timesheetFilterArea'>

                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => setStartDate(date)}
                                                placeholderText="Start Date"
                                                dateFormat="yyyy-MM-dd"
                                                className='datefilter'
                                            />

                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => setEndDate(date)}
                                                placeholderText="End Date"
                                                dateFormat="yyyy-MM-dd"
                                                className='datefilter'
                                            />

                                            <button
                                                className='filterBTN'
                                                onClick={() => filterTimesheet(item.user_id, item.company_id)}
                                            >
                                                Filter
                                            </button>

                                        </div>
                                    </div>
                                    <div className='vl_listing_cell width20'>
                                        <button onClick={() => goForTimeDetails(item.user_id, item.company_id)}>View</button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </section>
            </div>

            <div className='camp_log_pop'>
                <div className='camp_log_container'>
                    <div className='closebtnholder'>
                        <button className='closeBtn' onClick={closePopup}>+</button>
                    </div>
                    <h3>Timesheet For Last 30 Days</h3>
                    <div className='popcontentarea'>
                        {listMemberTimeArray.length > 0 && (
                            <>
                                <table className="activity-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Task</th>
                                            <th>Task Details</th>
                                            <th>Date</th>
                                            <th>Start</th>
                                            <th>End</th>
                                            <th>Worked</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listMemberTimeArray.map((task, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{task.task_name}</td>
                                                <td>{task.task_details}</td>
                                                <td>{task.dateofWork}</td>
                                                <td>{task.start_time}</td>
                                                <td>{task.end_time}</td>
                                                <td>{task.time_worked}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/* 📄 PDF Button */}
                                <button className='downlaodBTN'
                                    style={{ marginTop: '15px' }}
                                    onClick={downloadPDF}
                                >
                                    Download PDF <i className='ri-download-2-fill'></i>
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i class="ri-file-list-3-line"></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Close</button>
                    </div>
                </div>
            </div>

            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>


    )
}
